import { handleActions } from 'redux-actions';
import { assoc, head, propOr, pipe } from 'ramda';

import {
  requestGetListCardiovascularInvestigations,
  requestGetListCardiovascularInvestigationsSuccess,
  requestGetListCardiovascularInvestigationsFailure,
} from 'store/actionCreators/patient';
import { handleCVIData } from 'store/selectors/resources';

const defaultState = {
  loading: false,
  error: null,
  data: [],
};

export default handleActions(
  {
    [requestGetListCardiovascularInvestigations]: assoc('loading', true),
    [requestGetListCardiovascularInvestigationsSuccess]: (state, { payload: { response } }) =>
      pipe(
        assoc('loading', false),
        assoc('data', handleCVIData(response)),
      )(state),
    [requestGetListCardiovascularInvestigationsFailure]: (state, { payload: { response } }) =>
      pipe(
        assoc('loading', false),
        assoc(
          'error',
          pipe(
            propOr({}, 'issue'),
            head,
            propOr('', 'diagnostics'),
          )(response),
        ),
      )(state),
  },
  defaultState,
);
